export interface BadgeTheme {
  bg: string;
  color: string;
}

const statusThemes: Record<string, BadgeTheme> = {
  inprogress: {
    bg: "#E5F3FF",
    color: "#0085FF",
  },
  pending: {
    bg: "#FDF6DD",
    color: "#AD7636",
  },
  completed: {
    bg: "#E7F7ED",
    color: "#099D42",
  },
  inactive: {
    bg: "#FDE5DD",
    color: "#E0734F",
  },
  // Client-side "your move" badge: the brand red already used for alert badges.
  attention: {
    bg: "#FDE9EA",
    color: "#ED1C24",
  },
};

const statusSynonyms: Record<string, string> = {
  progress: "inprogress",
  "in-progress": "inprogress",
  "in progress": "inprogress",
  consultation: "inprogress",
  active: "inprogress",
  processing: "inprogress",
  preliminary_finals: "inprogress",
  final_review: "inprogress",

  waiting: "pending",
  waiting_for_client_response: "pending",
  ready_to_start: "inprogress",
  waiting_for_designer: "pending",
  waiting_on_design_team: "pending",
  pending_client_feedback: "attention",
  "on hold": "pending",
  onhold: "pending",
  "pending from client": "pending",
  "pending from designer": "pending",
  done: "completed",
  finished: "completed",
  complete: "completed",
  success: "completed",

  reject: "inactive",
  rejected: "inactive",
  deleted: "inactive",
  delete: "inactive",
  cancelled: "inactive",
  canceled: "inactive",
  cancel: "inactive",
  disabled: "inactive",
};

export const getBadgeTheme = (statusType?: string | null): BadgeTheme | null => {
  if (!statusType) return null;
  const normalized = statusType.toLowerCase();
  return statusThemes[statusSynonyms[normalized] || normalized] ?? null;
};
